import { useState } from "react";
import { Share2 } from "lucide-react";
import { toast } from "sonner";

// Bouton de partage natif (menu du téléphone : WhatsApp, Mail, SMS...) avec le PDF en pièce jointe.
// Repli : téléchargement direct du fichier si le partage natif n'est pas disponible.
const SharePdfButton = ({ url, filename, shareTitle, shareText, label, testid, className }) => {
    const [busy, setBusy] = useState(false);

    const handleShare = async () => {
        setBusy(true);
        try {
            const res = await fetch(url, { credentials: "include" });
            if (!res.ok) throw new Error("Impossible de récupérer le PDF");
            const blob = await res.blob();
            const file = new File([blob], filename, { type: "application/pdf" });
            if (navigator.canShare && navigator.canShare({ files: [file] })) {
                await navigator.share({ files: [file], title: shareTitle, text: shareText });
            } else {
                const blobUrl = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = blobUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                a.remove();
                setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
                toast.success("PDF téléchargé : partagez-le depuis Fichiers, Mail ou WhatsApp");
            }
        } catch (e) {
            if (e.name !== "AbortError") toast.error(e.message || "Partage impossible");
        } finally {
            setBusy(false);
        }
    };

    return (
        <button type="button" data-testid={testid} onClick={handleShare} disabled={busy} className={className}>
            <Share2 className="h-5 w-5" />
            {busy ? "Préparation..." : label}
        </button>
    );
};

export default SharePdfButton;
